// The host sizes the map by giving its container a definite height; the
// canvas fills it. `position: relative` anchors the absolutely-positioned
// zoom control + search overlay.
.root {
  height: 100%;
  position: relative;
  width: 100%;
  z-index: 0;
}
